import { config } from '../config/config';

export default class SignUp {
  private url: string = config.armcareNewServerUrl;

  /**
   * 
   * @param email user email to create account
   * @returns returns valid in true if the user does not exist, otherwise it indicates the role to which the email belongs
   */
  public async Validate(email: string): Promise<unknown> {
    const headers = new Headers({
      'Content-Type': 'application/json'
    });
    try {
      const response = await fetch(`${this.url}/v1/organizations/validate?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers,
      });

      const data = await response.json();
      return data;
    } catch (e) {
      return { status: false };
    }
  }

  /**
   * Create the organization
   * 
   * @param data.firstName 
   * @param data.lastName 
   * @param data.email 
   * @param data.password 
   * @param data.passwordConfirmation 
   * @returns returns the status of the request
   */
  public async AddOrganization(data: Object): Promise<unknown> {
    const body = JSON.stringify(data);
    const headers = new Headers({
      'Content-Type': 'application/json'
    });
    try {
      const response = await fetch(`${this.url}/v1/organizations/`, {
        method: 'POST',
        headers,
        body
      });

      const data = await response.json();
      return data;
    } catch (e) {
      return { status: false };
    }
  }

  /**
   * Delete the organization
   * 
   * @param email 
   * @returns returns the status of the request
   */
  public async DeleteOrganization(email: string): Promise<unknown> {
    const body = JSON.stringify({ email });
    const headers = new Headers({
      'Content-Type': 'application/json'
    });
    try {
      const response = await fetch(`${this.url}/v1/organizations/`, {
        method: 'DELETE',
        headers,
        body
      });

      const data = await response.json();
      return data;
    } catch (e) {
      return { status: false };
    }
  }

  /**
   * 
   * @param firstName 
   * @param lastName 
   * @param email 
   * @returns subscriptionId  and clientSecret
   */
  public async Subscriptions(firstName: string, lastName: string, email: string): Promise<unknown> {
    const body = JSON.stringify({
      firstName, lastName, email
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    try {
      const response = await fetch(`${this.url}/v1/subscriptions`, {
        method: 'POST',
        headers,
        body,
      });
      const data = await response.json();
      if (data.url) {
        return { ...data, success: true }
      } else {
        return { success: false }
      }
    } catch (e) {
      return { status: false };
    }
  }

  public async SuccessSubscription(email: string, session_id: string): Promise<unknown> {
    const body = JSON.stringify({
      email,
      session_id
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    try {
      const response = await fetch(`${this.url}/v1/subscriptions/successSubscription`, {
        method: 'POST',
        headers,
        body,
      });
      const data = await response.json();
      if (data.result === 'success') {
        return { ...data, success: true }
      } else {
        return { success: false }
      }
    } catch (e) {
      return { status: false };
    }
  }

  public async AddCoupon(subscriptionId: string, coupon: string): Promise<unknown> {
    const body = JSON.stringify({
      coupon,
      subscriptionId
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    try {
      const response = await fetch(`${this.url}/v1/subscriptions/addCouponStripe`, {
        method: 'PUT',
        headers,
        body,
      });
      const data = await response.json();
      if (data.clientSecret) {
        return { success: true }
      } else {
        return { success: false }
      }
    } catch (e) {
      return { status: false };
    }
  }
}
